//Importación de librerias
//---------------Cuentas---------------
//Catalogos
import C001Jueces from '../../../src/components/Cuentas/Usuarios/001Jueces.vue'
import C041TipoSexo from '../../../src/components/Cuentas/Catalogos/041TipoSexo.vue'
import C043TipoAbogado from '../../../src/components/Cuentas/Catalogos/043TipoAbogado.vue'
import C048TiposTitulo from '../../../src/components/Cuentas/Catalogos/048TiposTitulo.vue'
import C001OperadoresDeSala from '../../../src/components/Cuentas/Usuarios/001OperadoresDeSala.vue'
import C001Usuario from '../../../src/components/Cuentas/Usuarios/001UsuariosArea.vue'


//Creamos y asignamos los datos necesarios de cuentas
const cuentas = [
  { Proviene: 'Cuentas', Nombre: 'C001Jueces', datos: C001Jueces },
  { Proviene: 'Cuentas', Nombre: 'C041TipoSexo', datos: C041TipoSexo },
  { Proviene: 'Cuentas', Nombre: 'C043TipoAbogado', datos: C043TipoAbogado },
  { Proviene: 'Cuentas', Nombre: 'C048TiposTitulo', datos: C048TiposTitulo },
  { Proviene: 'Cuentas', Nombre: 'C001OperadoresDeSala', datos: C001OperadoresDeSala },
  { Proviene: 'Cuentas', Nombre: 'C001Usuario', datos: C001Usuario }
]


//Exportamos los datos de cuentas
export default cuentas;



//////////////////
// WEBPACK FOOTER
// ./static/js/catalogos/cuentas.js
// module id = null
// module chunks = 